export default __webpack_public_path__ + "static/media/B202.4e55d313.png";